<template>
    <div class="tooltip">
        <div class="tooltipText">
            <div :aria-label="tooltipText" />
        </div>
    </div>
</template>

<script>
    export default {
        props: ['tooltipText']
    }
</script>

<style lang="scss">
    .tooltipElement {
        position: relative;

        .tooltip {
            position: absolute;
            font-size: 10px;
            z-index: 100;
            display: none;
            top: 180%;
            left: 50%;
            transform: translate(-50%, -50%);

            .tooltipText {
                > div:after {
                    content: attr(aria-label);
                    background-color: #333333;
                    border-radius: 3px;
                    color: #ffffff;
                    padding: 8px 10px;
                    font-size: 12px;
                    line-height: 12px;
                    white-space: nowrap;
                }
                > div:before {
                    bottom: 100%;
                    left: 50%;
                    top: -25px;
                    border: solid transparent;
                    content: " ";
                    height: 0;
                    width: 0;
                    position: absolute;
                    pointer-events: none;
                }

                > div:before {
                    border-color: rgba(194, 225, 245, 0);
                    border-bottom-color: #333333;
                    border-width: 8px;
                    margin-left: -8px;
                }
            }
        }

        &:hover {
            .tooltip {
                display: inline-block;
            }

            .tooltipHide ~.tooltip,
            select:focus ~.tooltip {
                display: none;
            }
        }

        &.tooltipRight {
            .tooltip {
                top: 50%;
                left: 115%;
                transform: translate(0%, -50%);

                .tooltipText {
                    > div:before {
                        right: 100%;
                        top: 50%;
                        left: unset;
                    }

                    > div:before {
                        border-color: rgba(194, 225, 245, 0);
                        border-right-color: #333333;
                        border-width: 8px;
                        margin-top: -8px;
                    }
                }
            }
        }
    }
</style>